// M2 — public current-policy API helper (no authentication). Reuses the app's API base.
import { API_BASE } from "./api";

// Build the unauthenticated current-policy PDF URL. `download` switches to attachment disposition.
export function policyPdfUrl(slug, { download = false } = {}) {
  const base = `${API_BASE}/public/legal/${slug}/pdf`;
  return download ? `${base}?disposition=attachment` : base;
}

// Format "D Month YYYY" from an ISO timestamp using the Asia/Kolkata (IST) calendar date.
// e.g. "12 June 2026". Date-only (no time-of-day), so no IST suffix is shown.
export function formatPublishedDate(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Kolkata", day: "numeric", month: "long", year: "numeric",
  }).format(d);
}

// Fetch current-policy metadata { slug, title, system_version, published_at }. Public (no auth).
// Throws an Error with `.notFound` + `.reasonCode` for 404s, or a generic error otherwise.
export async function fetchPublicPolicy(slug) {
  let res;
  try {
    res = await fetch(`${API_BASE}/public/legal/${slug}`, { headers: { Accept: "application/json" } });
  } catch (e) {
    const err = new Error("LOAD_ERROR");
    err.notFound = false;
    throw err;
  }
  if (res.status === 404) {
    let reasonCode = "UNKNOWN_POLICY";
    try {
      const body = await res.json();
      reasonCode = (body && body.detail && body.detail.reason_code) || reasonCode;
    } catch (e) { /* keep default */ }
    const err = new Error(reasonCode);
    err.notFound = true;
    err.reasonCode = reasonCode;
    throw err;
  }
  if (!res.ok) {
    const err = new Error("LOAD_ERROR");
    err.notFound = false;
    throw err;
  }
  return res.json();
}
